package Structs

import Utils.getJsonWithConfig
import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive

/**
 * value_data.details is stored inconsistently: legacy rows use a string with @ instead of "
 * (e.g. "[{@id@:@14@,...}]"); newer rows store a parsed JSON array. Normalize to the legacy
 * string form so ProductDelivery.createFromJson(details.replace("@", "\"")) keeps working.
 */
object ClientTaxNoteDetailsSerializer : KSerializer<String> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("ClientTaxNoteDetails", PrimitiveKind.STRING)

    override fun serialize(encoder: Encoder, value: String) {
        encoder.encodeString(value)
    }

    override fun deserialize(decoder: Decoder): String {
        val jsonDecoder = decoder as? JsonDecoder
        if (jsonDecoder != null) {
            return when (val element = jsonDecoder.decodeJsonElement()) {
                is JsonPrimitive -> element.content
                is JsonArray, is JsonObject ->
                    getJsonWithConfig()
                        .encodeToString(JsonElement.serializer(), element)
                        .replace("\"", "@")
                else -> ""
            }
        }
        return decoder.decodeString()
    }
}
